const getSolutionsProductFeatures = (variantTypeDetails)=>{
    const { hasDisinfect , forHydration , additionalComfort , superiorCleaning , forSensitiveEyes , rinsable ,  } = variantTypeDetails;
    const productFeatures = [];
    if (!!hasDisinfect) {
        productFeatures.push({
            type: 'disinfect',
            iconName: 'disinfect',
            labelKey: 'products.solutions.features.cbDisinfect'
        });
    }
    if (!!forHydration) {
        productFeatures.push({
            type: 'hydration',
            iconName: 'hydration',
            labelKey: 'products.solutions.features.cbHydration'
        });
    }
    if (!!additionalComfort) {
        productFeatures.push({
            type: 'comfort',
            iconName: 'comfort',
            labelKey: 'products.solutions.features.cbComfort'
        });
    }
    if (!!superiorCleaning) {
        productFeatures.push({
            type: 'cleaning',
            iconName: 'cleaning',
            labelKey: 'products.solutions.features.cbCleaning'
        });
    }
    if (!!forSensitiveEyes) {
        productFeatures.push({
            type: 'sensitivity',
            iconName: 'sensitivity',
            labelKey: 'products.solutions.features.cbSensitivity'
        });
    }
    if (!!rinsable) {
        productFeatures.push({
            type: 'rinsing',
            iconName: 'rinsing',
            labelKey: 'products.solutions.features.cbRinsing'
        });
    }
    return productFeatures;
};

export { getSolutionsProductFeatures };
//# sourceMappingURL=get-solutions-product-features.js.map
